// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__297i_","itemA":"Write_itemA__3AXK1","itemB":"Write_itemB__34D4f","itemC":"Write_itemC__1kUgw","itemD":"Write_itemD__2cOyo"};